import { useQuery } from '@tanstack/react-query';
import { hybridApi } from '../services/api';

interface DashboardMetrics {
  today: {
    sales: number;
    orders: number;
    averageOrderValue: number;
  };
  yesterday: {
    sales: number;
    orders: number;
  };
  current: {
    revenue: number;
    orderCount: number;
    averageOrderValue: number;
    totalSales: number;
  };
  mtd: {
    sales: number;
    orders: number;
    averageOrderValue: number;
    revenue: number;
    orderCount: number;
    totalSales: number;
  };
  ytd: {
    sales: number;
    orders: number;
    averageOrderValue: number;
    revenue: number;
    orderCount: number;
    totalSales: number;
  };
  comparisons: {
    dayOverDay: {
      salesChange: number;
      ordersChange: number;
    };
  };
}

export const useDashboardMetrics = (date?: string, storeId?: string) => {
  return useQuery<{ data: DashboardMetrics }, Error, DashboardMetrics>({
    queryKey: ['dashboard-metrics', date, storeId],
    queryFn: async () => {
      const response = await hybridApi.getDashboardMetrics(date, storeId);
      return response;
    },
    select: (data) => data.data,
    staleTime: 60000, // 1 minute
    refetchInterval: 300000, // 5 minutes
  });
};